var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    ref: "timeMenu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.time,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        _vm.time = $event;
      },
      "update:return-value": function updateReturnValue($event) {
        _vm.time = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn() {
        return [_c('v-menu', {
          ref: "dateMenu",
          attrs: {
            "close-on-content-click": false,
            "return-value": _vm.date,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          on: {
            "update:returnValue": function updateReturnValue($event) {
              _vm.date = $event;
            },
            "update:return-value": function updateReturnValue($event) {
              _vm.date = $event;
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn() {
              return [_c('v-text-field', {
                attrs: {
                  "label": _vm.label,
                  "placeholder": _vm.placeholder,
                  "dense": _vm.dense,
                  "hide-details": _vm.hideDetails,
                  "append-icon": "event",
                  "clearable": _vm.clearable,
                  "readonly": ""
                },
                on: {
                  "click": function click($event) {
                    _vm.showDatePicker = true;
                  }
                },
                model: {
                  value: _vm.datetime,
                  callback: function callback($$v) {
                    _vm.datetime = $$v;
                  },
                  expression: "datetime"
                }
              })];
            },
            proxy: true
          }]),
          model: {
            value: _vm.showDatePicker,
            callback: function callback($$v) {
              _vm.showDatePicker = $$v;
            },
            expression: "showDatePicker"
          }
        }, [_c('v-date-picker', {
          attrs: {
            "type": _vm.type,
            "no-title": "",
            "scrollable": ""
          },
          on: {
            "input": function input($event) {
              _vm.$refs.dateMenu.save(_vm.date);

              _vm.showDatePicker = false;
              _vm.showTimePicker = true;
            }
          },
          model: {
            value: _vm.date,
            callback: function callback($$v) {
              _vm.date = $$v;
            },
            expression: "date"
          }
        })], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showTimePicker,
      callback: function callback($$v) {
        _vm.showTimePicker = $$v;
      },
      expression: "showTimePicker"
    }
  }, [_vm.showTimePicker ? _c('v-time-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "click:minute": function clickMinute($event) {
        _vm.$refs.timeMenu.save(_vm.time);

        _vm.showTimepicker = false;
        _vm.datetime = [_vm.date, _vm.time].join(' ');
      }
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }